import { useParams } from 'react-router-dom';
import { Page, PageTitleWithBack } from '../../../components';
import { Box } from '@mui/material';
import { DynamicFileMangementEditor } from './dynamic-file-management-editor';

export const DynamicFileManagementEditPage = () => {
  const { pandaDocTemplateId } = useParams<{
    pandaDocTemplateId: string;
  }>();

  return (
    <Page
      title="Edit File"
      customBreadcrumbPath="/documentation/build-documentation/file-management/edit-file"
    >
      <Box display="flex" alignItems="center">
        <Box flex={1}>
          <PageTitleWithBack
            title="Edit File"
            backUrl="/documentation/build-documentation/file-management"
            backText="Back to File Management"
          />
        </Box>
      </Box>
      <DynamicFileMangementEditor pandaDocTemplateId={pandaDocTemplateId} />
    </Page>
  );
};
